// extracted by mini-css-extract-plugin
export default {"container":"P0-z","heading":"Q0-z","links":"R0-z","copy":"S0-z","subCopy":"T0-z","linksLeft":"U0-z","linksCenter":"V0-z","linksRight":"W0-z","link":"X0-z","onlyLink":"Y0-z"};